import {PaymentTypes} from '../services/resources';

const state = {};

const mutations = {};

const actions = {
    getPaymentTypes(context, pagination) {
        return PaymentTypes.getPaymentTypes(pagination).then((response) => {
            return response.data;
        });
    },
    getPaymentType(context, id) {
        return PaymentTypes.get({id}).then((response) => {
            return response.data;
        });
    },
    createPaymentType(context, item) {
        return PaymentTypes.create(item).then((response) => {
            return response.data;
        });
    },
    updatePaymentType(context, item) {
        return PaymentTypes.update(item).then((response) => {
            return response.data;
        });
    },
    destroyPaymentType(context, item) {
        return PaymentTypes.destroy(item).then((response) => {
            return response.data;
        });
    },
    getPaymentTypeField(context, item) {
        return PaymentTypes.getPaymentTypeField(item).then((response) => {
            return response.data;
        });
    },
};

const module = {
    state,
    mutations,
    actions
};

export default module;
